export const ENV = process.env.REACT_APP_APP_ENV || 'dev3';

export const ROLLBAR_TOKEN = '165ad6c0df5141519baa3aebb484151c';
